import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { IconButton, InputAdornment } from "@mui/material"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'

export default function ContractAdjustmentModal({
    rentalContractItem,
    open,
    closeModal
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [adjustmentValue, setAdjustmentValue] = React.useState(0)
    const [adjustmentDescription, setAdjustmentDescription] = React.useState("")

    const save = () => {
        const my_adjustment = {
            description: adjustmentDescription,
            value: adjustmentValue
        }
        send_authorized_request(() =>
        AXIOS_API_INSTANCE.put(
            `rentalcontractitems/${rentalContractItem.id}/adjustment`,
            my_adjustment
        ).then((rentalContractItemAdjustment) => {
            enqueueSnackbar('Successfully added adjustment to contract', { variant: 'success' })
            closeModal(true)
        }).catch((error) => {
            enqueueSnackbar(`Failed to add adjustment to contract contract <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
        })
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    {"Creating Adjustment"}
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="description"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="filled"
                        value={adjustmentDescription}
                        onChange={(event) => setAdjustmentDescription(event.target.value)}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="adjustmentamount"
                        label="Adjustment Amount"
                        type="number"
                        fullWidth
                        variant="standard"
                        value={adjustmentValue}
                        onChange={(event) => setAdjustmentValue(event.target.value)}
                        sx={{ minWidth: '125px' }}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {<AttachMoneyIcon />}
                                    </InputAdornment>
                                ),
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save}>
                                Create
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
